<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 my-2 pb-3 w-100">
    <div class="d-flex justify-content-between">
      <img
        *ngIf="stepper !== 1"
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <h1 class="modal-title m-auto">{{ 'ADD_A_DEVICE' | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mb-3">
    <p class="text-center heading-one">{{ 'SELECT_A_DEVICE_TYPE' | translate }}</p>
    <p class="paragraph-text text-center px-2 mx-4">
      {{ 'SELECT_A_PROPER_DEVICE_TYPE' | translate }}
    </p>
  </div>

  <div class="container lock-detail px-2 mb-160">
    <div class="group-container">
      <form
        [formGroup]="deviceTypeForm"
        (keydown.enter)="navigateToNextStep()"
        #deviceType
        tabindex="0"
        [attr.autofocus]="focusOnNameModal ? '' : null"
      >
        <ng-container *ngFor="let radionButton of radionButtons; let i = index">
          <div
            (click)="radioRef.click(); activate(radionButton)"
            class="checked-card"
            [class.active]="radionButton.active"
          >
            <img
              [src]="
                radionButton.active
                  ? 'assets/svg/ico-checkmark-circle-outline.svg'
                  : 'assets/svg/ico-circle.svg'
              "
              class="check-circle"
            />
            <div class="content-box">
              <input
                type="radio"
                class="d-none"
                [value]="radionButton.value"
                #radioRef
                formControlName="deviceType"
              />
              <h3 class="title">{{ radionButton.label }}</h3>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
  <div class="row w-100 px-3 py-3">
    <div class="w-100">
      <button
        class="btn btn-danger update-btn px-3"
        [disabled]="!deviceTypeForm.valid"
        (click)="navigateToNextStep()"
      >
        {{ 'CONTINUE' | translate }}
      </button>
    </div>
  </div>
</div>
